<template>
  <KekkleCard>
    <div class="">
      <h1 class="text-xl font-bold dark:text-slate-200">
        {{ $t("auth.Delete my account") }} : {{ userEmail }}
      </h1>
    </div>
    <div v-if="stepNumber === 0">
      <p>
        {{ $t("auth.Are you sure you want to delete your account?") }}
      </p>
      <div class="mt-6 flex">
        <default-button @click="$router.push({ name: 'Group' })">{{
          $t("auth.No go back")
        }}</default-button>
        <default-button color="red" @click="stepNumber++">{{
          $t("auth.Yes proceed")
        }}</default-button>
      </div>
    </div>
    <div v-if="stepNumber === 1">
      <p>
        {{
          $t(
            "auth.are you really sure you want to delete your account on this amazing app?",
          )
        }}
      </p>
      <div class="mt-6 flex">
        <default-button color="red" @click="stepNumber++">
          {{ $t("auth.Yes proceed") }}</default-button
        >
        <default-button @click="$router.push({ name: 'Group' })">{{
          $t("auth.No go back")
        }}</default-button>
      </div>
    </div>
    <div v-if="stepNumber === 2">
      <p>
        {{
          $t(
            "auth.Are you really sure you do not want to create some fun memories??",
          )
        }}
      </p>
      <div class="mt-6 flex">
        <default-button @click="$router.push({ name: 'Group' })">
          {{ $t("auth.No go back") }}</default-button
        >
        <default-button color="red" @click="stepNumber++">{{
          $t("auth.Yes proceed")
        }}</default-button>
      </div>
    </div>
    <div v-if="stepNumber === 3">
      <p>{{ $t("auth.Alright time to let go") }}</p>
      <div class="mt-6 flex">
        <default-button
          :loading="deleting"
          color="red"
          @click="deleteAccount"
          >{{ $t("auth.Delete my account forever") }}</default-button
        >
        <default-button
          v-if="!deleting"
          @click="$router.push({ name: 'Group' })"
          >{{ $t("auth.Fuck go back") }}</default-button
        >
      </div>
    </div>
  </KekkleCard>
</template>
<script>
import DefaultButton from "../components/Buttons/DefaultButton.vue";
import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "@/helpers/firebase/firebase";
import { setErrorToast, setSuccessToast } from "@/helpers/notifications/toast";
import { useAuthStore } from "@/stores/modules/auth/auth";
import * as Sentry from "@sentry/vue";
import KekkleCard from "@/components/ui/KekkleCard.vue";

export default {
  name: "DeleteAccount",
  components: {
    DefaultButton,
    KekkleCard,
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data: function () {
    return {
      stepNumber: 0,
      deleting: false,
    };
  },
  computed: {
    userEmail() {
      return this.authStore.firebaseAuthUser?.email;
    },
  },
  methods: {
    async deleteAccount() {
      this.deleting = true;
      const deleteGroupFunction = await httpsCallable(
        firebaseFunctions,
        "deleteAccount",
      );
      try {
        await deleteGroupFunction();
        setSuccessToast({
          message: this.$t("auth.delete_account_success"),
        });
        setTimeout(async () => {
          await this.authStore.logout();
        }, 2000);
      } catch (e) {
        Sentry.captureException(e);
        setErrorToast({
          message: this.$t("auth.delete_account_failed"),
        });
      } finally {
        this.deleting = false;
      }
    },
  },
};
</script>
